import { GET } from '@/request/index'
import URL from '@/request/api/url'

export const fetchRecruitmentDetail = (id) => {
  return GET(URL.RECRUITMENT_DETAIL + id)
}
